module.exports = __webpack_public_path__ + "img/down_from.00136900.svg";